<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex align-items-center pb-5">
          <div class="col px-0">
            <div
              class="row row-grid justify-content-between align-items-center"
            >
              <div class="col-lg-5">
                <div class="d-flex align-items-center">
                  <img
                    src="img/main/orchardBiotech.png"
                    style="width: 60px"
                    class="img-fluid"
                  />
                  <h4 class="display-4 text-normal mb-0 pl-2">
                    傲卓集團科技有限公司
                  </h4>
                </div>
                <p class="lead text-normal">
                  傲卓集團科技有限公司乃傲卓集團有限公司旗下的研發及開拓純天然產品的子公司，致力研發及引入各地以純天然成分的產品作為在香港或以外地方推廣
                </p>
                <div class="btn-wrapper">
                  <base-button
                    tag="a"
                    href="#about"
                    class="mb-3 mb-sm-0"
                    type="default"
                    icon="fa fa-arrow-down"
                  >
                    繼續瀏覽
                  </base-button>
                </div>
              </div>
              <div class="col-lg-6 mb-lg-auto">
                <b-carousel id="carousel1" controls indicators :interval="2500">
                  <b-carousel-slide img-src="img/main/p2.png" />
                  <b-carousel-slide img-src="img/main/p3.png" />
                  <b-carousel-slide img-src="img/main/p4.png" />
                  <b-carousel-slide img-src="img/main/p5.png" />
                  <b-carousel-slide img-src="img/main/p6.png" />
                  <b-carousel-slide img-src="img/main/p7.png" />
                </b-carousel>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
  </div>
</template>
<script>
import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";

export default {
  components: {
    BCarousel,
    BCarouselSlide,
  },
};
</script>
<style>
.carousel-inner {
  box-shadow: 2px 4px 10px #999;
  border-radius: 5px;
}
</style>
